import type { OutgoingStatisticsResponse } from '../../../store/reducers/OutgoingStatisticsSlice';

export interface OutgoingStatisticMetrics {
  readonly totalTasksCount: number;
  readonly processedTasksCount: number;
  readonly processedTasksAttemptCount: number;
  readonly noAttemptTasksCount: number;
  readonly failedTasksCount: number;
  readonly technicalTasksCount: number;
  readonly oneAttemptTasksCount: number;
  readonly twoAttemptTasksCount: number;
  readonly threeAndMoreAttemptTasksCount: number;
  readonly oneAttemptBusinessResultTasksAttemptCount: number;
  readonly oneAttemptTechnicalResultTasksAttemptCount: number;
  readonly twoAttemptBusinessResultTasksAttemptCount: number;
  readonly twoAttemptTechnicalResultTasksAttemptCount: number;
  readonly threeAndMoreAttemptTasksAttemptCount: number;
  readonly technicalTasksAttemptCount: number;
  readonly notIdentifiedAttemptCount: number;
  readonly misCancelledAttemptCount: number;
}

const sumTaskTotalBuckets = (statistic: OutgoingStatisticsResponse) =>
  statistic.processedTasksCount +
  statistic.inProcessingTasksCount +
  statistic.notProcessedTasksCount +
  statistic.blockedTasksCount;

export const buildOutgoingStatisticMetrics = (
  statistic: OutgoingStatisticsResponse,
): OutgoingStatisticMetrics => {
  const totalTasksCount = sumTaskTotalBuckets(statistic);
  const oneAttemptTasksCount =
    statistic.oneAttemptBusinessResultTasksCount +
    statistic.oneAttemptTechnicalResultTasksCount;
  const twoAttemptTasksCount =
    statistic.twoAttemptBusinessResultTasksCount +
    statistic.twoAttemptTechnicalResultTasksCount;
  const threeAndMoreAttemptTasksCount =
    statistic.threeAndMoreAttemptBusinessResultTasksCount +
    statistic.threeAndMoreAttemptTechnicalResultTasksCount;
  const technicalTasksCount =
    statistic.oneAttemptTechnicalResultTasksCount +
    statistic.twoAttemptTechnicalResultTasksCount +
    statistic.threeAndMoreAttemptTechnicalResultTasksCount;
  const oneAttemptBusinessResultTasksAttemptCount =
    statistic.oneAttemptBusinessResultTasksCount;
  const oneAttemptTechnicalResultTasksAttemptCount =
    statistic.oneAttemptTechnicalResultTasksCount;
  const twoAttemptBusinessResultTasksAttemptCount =
    statistic.twoAttemptBusinessResultTasksCount * 2;
  const twoAttemptTechnicalResultTasksAttemptCount =
    statistic.twoAttemptTechnicalResultTasksCount * 2;
  const threeAndMoreAttemptTasksAttemptCount =
    statistic.threeAndMoreAttemptBusinessResultTasksAttemptCount +
    statistic.threeAndMoreAttemptTechnicalResultTasksAttemptCount;
  const technicalTasksAttemptCount =
    oneAttemptTechnicalResultTasksAttemptCount +
    twoAttemptTechnicalResultTasksAttemptCount +
    statistic.threeAndMoreAttemptTechnicalResultTasksAttemptCount;
  const misCancelledAttemptCount = Math.max(
    technicalTasksAttemptCount -
      statistic.failedTasksAttemptCount -
      statistic.notIdentifiedTasksAttemptCount,
    0,
  );

  return {
    totalTasksCount,
    processedTasksCount: statistic.processedTasksCount,
    processedTasksAttemptCount: statistic.processedTasksAttemptCount,
    noAttemptTasksCount:
      statistic.cancelledByClinicTasksCount +
      statistic.rescheduledByClinicTasksCount,
    failedTasksCount: statistic.failedTasksCount,
    technicalTasksCount,
    oneAttemptTasksCount,
    twoAttemptTasksCount,
    threeAndMoreAttemptTasksCount,
    oneAttemptBusinessResultTasksAttemptCount,
    oneAttemptTechnicalResultTasksAttemptCount,
    twoAttemptBusinessResultTasksAttemptCount,
    twoAttemptTechnicalResultTasksAttemptCount,
    threeAndMoreAttemptTasksAttemptCount,
    technicalTasksAttemptCount,
    notIdentifiedAttemptCount: statistic.notIdentifiedTasksAttemptCount,
    misCancelledAttemptCount,
  };
};
